// initial state
import axios from 'axios'

const state = () => ({
  modules_enabled: {
    cancerregistry: process.env.VUE_APP_CANCERREGISTRY_MODULE_ENABLED ? process.env.VUE_APP_CANCERREGISTRY_MODULE_ENABLED == 'true' ? true : false : false,
    survey: process.env.VUE_APP_SURVEY_MODULE_ENABLED ? process.env.VUE_APP_SURVEY_MODULE_ENABLED == 'true' ? true : false : false,
    knowledgebase: process.env.VUE_APP_KNOWLEDGEBASE_MODULE_ENABLED ? process.env.VUE_APP_KNOWLEDGEBASE_MODULE_ENABLED == 'true' ? true : false : false,
  },
  route_name_after_login: process.env.VUE_APP_ROUTE_NAME_AFTER_LOGIN ? process.env.VUE_APP_ROUTE_NAME_AFTER_LOGIN : 'dashboard',
  has_valid_license: false,
  diagnoseIdsForTherapyProtocolBiomarkerFilter: [2, 3, 13, 63, 8, 39, 11, 33, 49, 45, 6],
})

// getters
const getters = {
  modules_enabled: ({ modules_enabled }) => modules_enabled,
  route_name_after_login: ({ route_name_after_login }) => route_name_after_login,
  has_valid_license: ({ has_valid_license }) => has_valid_license,
  diagnoseIdsForTherapyProtocolBiomarkerFilter: ({ diagnoseIdsForTherapyProtocolBiomarkerFilter }) => diagnoseIdsForTherapyProtocolBiomarkerFilter
}

// actions
const actions = {
  async validateLicense() {
    await axios.get('/license/')
    await axios.get('/license/')
  },
}

// mutations
const mutations = {
  setLicenseStatus(state, status) {
    state.has_valid_license = typeof status === 'boolean' ? status : (status === 'true' || status === 'false' ? (status === 'true') : false)
  },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
